import React from 'react';
import { Images, User, Building, Camera } from 'lucide-react';
import Card from '../../../components/ui/card';
import ImageSlotManager from './image-management/ImageSlotManager';

const ClientImagesPanel = ({ client, clientImages }) => {
	const imageCategories = [
		{
			type: 'headshot',
			title: 'Headshots',
			icon: User,
			maxSlots: 3,
			description: 'Professional headshots for user profile',
		},
		{
			type: 'logo',
			title: 'Personal Logos',
			icon: Building,
			maxSlots: 3,
			description: 'User personal branding logos',
		},
		{
			type: 'broker_logo',
			title: 'Broker Logos',
			icon: Building,
			maxSlots: 2,
			description: 'User brokerage logos and branding',
		},
		{
			type: 'lifestyle',
			title: 'Lifestyle Photos',
			icon: Camera,
			maxSlots: 3,
			description: 'User lifestyle and marketing photos',
		},
	];

	return (
		<div className='space-y-6'>
			<Card className='border-l-2 border-l-primary/20'>
				<Card.Header className='border-b border-gray-100'>
					<Card.Title className='flex items-center text-sm sm:text-base font-glacial uppercase tracking-wider text-gray-900'>
						<Images className='w-4 h-4 mr-2 text-primary' />
						Image Management
					</Card.Title>
				</Card.Header>
				<Card.Content>
					<p className='text-sm font-montserrat-regular text-gray-400 mb-6'>
						Manage client images organized by type and slot.
					</p>

					<div className='space-y-8'>
						{imageCategories.map((category) => (
							<div
								key={category.type}
								className='border-b border-gray-100 last:border-0 pb-6 last:pb-0'>
								<div className='flex items-center mb-2'>
									<category.icon className='w-3.5 h-3.5 text-primary/60 mr-1.5' />
									<h3 className='text-sm font-montserrat-medium text-gray-700'>
										{category.title}
									</h3>
									{category.maxSlots && (
										<span className='ml-2 text-xs font-montserrat-regular text-gray-400'>
											(Max {category.maxSlots})
										</span>
									)}
								</div>
								<p className='text-xs font-montserrat-regular text-gray-400 mb-3'>
									{category.description}
								</p>

								<ImageSlotManager
									client={client}
									imageType={category.type}
									maxSlots={category.maxSlots}
									title={category.title}
									description={category.description}
								/>
							</div>
						))}
					</div>
				</Card.Content>
			</Card>
		</div>
	);
};

export default ClientImagesPanel;
